import { Component, type ReactNode } from "react";
import { AppProvider, Page, Banner } from "@shopify/polaris";
import { NavMenu } from "@shopify/app-bridge-react";
import { Routes, Route, Navigate } from "react-router-dom";
import enTranslations from "@shopify/polaris/locales/en.json";
import Dashboard from "./pages/Dashboard";
import Configuration from "./pages/Configuration";
import Products from "./pages/Products";
import Plans from "./pages/Plans";
import AutoTranslate from "./pages/AutoTranslate";

class ErrorBoundary extends Component<
	{ children: ReactNode },
	{ error: Error | null }
> {
	state = { error: null as Error | null };

	static getDerivedStateFromError(error: Error) {
		return { error };
	}

	render() {
		if (this.state.error) {
			return (
				<Page title="Error">
					<Banner tone="critical">
						<p>Something went wrong: {this.state.error.message}</p>
						<pre style={{ fontSize: "12px", marginTop: "8px" }}>
							{this.state.error.stack}
						</pre>
					</Banner>
				</Page>
			);
		}
		return this.props.children;
	}
}

export default function App() {
	return (
		<AppProvider i18n={enTranslations}>
			<NavMenu>
				<a href="/" rel="home">Dashboard</a>
				<a href="/configuration">Configuration</a>
				<a href="/auto-translate">Auto-Translate</a>
				<a href="/products">Products</a>
				<a href="/plans">Plans</a>
			</NavMenu>
			<ErrorBoundary>
				<Routes>
					<Route path="/" element={<Dashboard />} />
					<Route path="/configuration" element={<Configuration />} />
					<Route path="/auto-translate" element={<AutoTranslate />} />
					<Route path="/products" element={<Products />} />
					<Route path="/translate" element={<Navigate to="/products" replace />} />
					<Route path="/plans" element={<Plans />} />
				</Routes>
			</ErrorBoundary>
		</AppProvider>
	);
}
